import http from '@/core/http'

const url = 'carteira'

const state = {
  withdraws: [],
  totalItens: 0,
  loadingBalance: false,
  creditBalance: 0,
  lastBalanceUpdate: null,
  withdrawBalance: 0,
  accruedCommissions: 0,
  hasCnpj: false,
  minWithdrawAmount: 0,
  subAffiliateCommissions: 0,
  ftdCount: 0,
  paymentsReceived: 0,
  hasPaymentMethod: false,
}

const actions = {
  getItens: async ({ commit }, payload) => {
    commit('SET_LOADING_BALANCE', true)
    const headers = { moduloname: 'afiliados' }
    try {
      const result = await http.get(url, { params: payload, headers })
      commit('LISTA_ITENS', result.data)
      return result
    } finally {
      commit('SET_LOADING_BALANCE', false)
    }
  },

  // Used by the sidebar to refresh the balance without touching state.withdraws.
  getSaldoAtual: async ({ commit }) => {
    commit('SET_LOADING_BALANCE', true)
    const headers = { moduloname: 'afiliados' }
    const today = new Date().toISOString().slice(0, 10)
    try {
      const result = await http.get(url, { params: { dtStart: today, dtEnd: today }, headers })
      commit('SET_SALDO', result.data)
      return result
    } finally {
      commit('SET_LOADING_BALANCE', false)
    }
  },

  sacar: async (_, payload) => {
    const headers = { moduloname: 'afiliados' }
    const result = await http.post(`${url}/saque`, payload, { headers })
    return Promise.resolve(result)
  },
}

const mutations = {
  'SET_LOADING_BALANCE' (state, payload) {
    state.loadingBalance = payload
  },

  // Only updates balance-related fields — does NOT touch withdraws or totalItens.
  'SET_SALDO' (state, payload) {
    state.creditBalance = payload.creditBalance
    state.lastBalanceUpdate = payload.lastBalanceUpdate || null
    state.withdrawBalance = payload.withdrawBalance
    state.accruedCommissions = payload.accruedCommissions || 0
    state.hasCnpj = payload.hasCnpj
    state.minWithdrawAmount = payload.minWithdrawAmount || 0
    state.subAffiliateCommissions = payload.subAffiliateCommissions || 0
    state.ftdCount = payload.ftdCount || 0
    state.paymentsReceived = payload.paymentsReceived || 0
    state.hasPaymentMethod = payload.hasPaymentMethod || false
  },

  'LISTA_ITENS' (state, payload) {
    state.withdraws = payload.withdraws || []
    state.totalItens = state.withdraws.length
    state.creditBalance = payload.creditBalance
    state.lastBalanceUpdate = payload.lastBalanceUpdate || null
    state.withdrawBalance = payload.withdrawBalance
    state.accruedCommissions = payload.accruedCommissions
    state.hasCnpj = payload.hasCnpj
    state.minWithdrawAmount = payload.minWithdrawAmount || 0
    state.subAffiliateCommissions = payload.subAffiliateCommissions || 0
    state.ftdCount = payload.ftdCount || 0
    state.paymentsReceived = payload.paymentsReceived || 0
    state.hasPaymentMethod = payload.hasPaymentMethod || false
  },
}

const getters = {
  withdraws: state => state.withdraws,
  totalItens: state => state.totalItens,
  loadingBalance: state => state.loadingBalance,
  creditBalance: state => state.creditBalance,
  lastBalanceUpdate: state => state.lastBalanceUpdate,
  withdrawBalance: state => state.withdrawBalance,
  accruedCommissions: state => state.accruedCommissions,
  hasCnpj: state => state.hasCnpj,
  minWithdrawAmount: state => state.minWithdrawAmount,
  subAffiliateCommissions: state => state.subAffiliateCommissions,
  ftdCount: state => state.ftdCount,
  paymentsReceived: state => state.paymentsReceived,
  hasPaymentMethod: state => state.hasPaymentMethod,
}

export default { namespaced: true, state, actions, mutations, getters }
